import { makeStyles } from '@material-ui/core/styles';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { createElement } from 'react';
import { TextColors } from '@/utils/constants';
import { encodeSvg } from '@/utils/helpers';

const darkTheme = {
  root: {
    color: TextColors.light,

    '& $heading': {
      color: TextColors.light,
    },

    '& $rtc': {
      '& a[href]': {
        '&:after': {
          backgroundImage: `url(${encodeSvg(
            createElement(ChevronRight, {
              xmlns: 'http://www.w3.org/2000/svg',
              fill: TextColors.light,
            }),
          )})`,

          '&:hover': {
            color: TextColors.light,
          },
        },
      },

      '& a[href], & a[href]:not(:hover)': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    color: TextColors.dark,

    '& $heading': {
      color: TextColors.dark,
    },

    '& $rtc': {
      '& a[href]': {
        '&:after': {
          backgroundImage: `url(${encodeSvg(
            createElement(ChevronRight, {
              xmlns: 'http://www.w3.org/2000/svg',
              fill: TextColors.dark,
            }),
          )})`,

          '&:hover': {
            color: TextColors.dark,
          },
        },
      },

      '& a[href], & a[href]:not(:hover)': {
        color: TextColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      padding: '32px 24px',
      position: 'relative',

      [muiTheme.breakpoints.up('md')]: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '40px',
      },
    },
    heading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(1),
      },
    },
    img: {
      display: 'block',

      '&.margin-bottom': {
        marginBottom: '1em',
      },

      '& > *': {
        [muiTheme.breakpoints.up('md')]: {
          maxHeight: '100%',
        },
      },

      [muiTheme.breakpoints.down('sm')]: {
        margin: '0 auto',
      },

      [muiTheme.breakpoints.up('md')]: {
        height: '90px',

        '& img': {
          maxHeight: '90px',
          maxWidth: '460px !important',
        },
      },
    },
    noMargin: {
      marginBottom: '0 !important',
    },

    columnContent: {
      flex: 1,
      zIndex: 5,

      '& + *': {
        [muiTheme.breakpoints.up('md')]: {
          marginLeft: '32px',
        },

        [muiTheme.breakpoints.down('sm')]: {
          marginTop: '25px',
        },
      },
    },
    rtc: {
      ...muiTheme.typography.body2,

      [muiTheme.breakpoints.up('md')]: {
        ...muiTheme.typography.body1,
      },

      '& * + *': {
        marginTop: '.5em',
      },

      '& a[href], & a[href]:not(:hover), & h1, & h2, & h3, & h4, & h5, & h6': {
        textDecoration: 'none',
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: 'normal',
        display: 'block',
        marginBottom: 0,

        [muiTheme.breakpoints.up('md')]: {
          fontSize: '30px',
        },
      },

      '& a[href]': {
        transition: 'color 150ms ease-out',

        '&:before': {
          content: '""',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          zIndex: 1,
          display: 'block',
          position: 'absolute',
        },

        '&:after': {
          content: '""',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          display: 'inline-block',
          marginLeft: '8px',
          marginRight: '-4px',
          marginTop: '-2px',
          height: '28px',
          verticalAlign: 'middle',
          width: '28px',
        },

        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
    columnCta: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      width: '100%',
      position: 'relative',
      zIndex: 1,

      [muiTheme.breakpoints.up('md')]: {
        maxWidth: '280px',
      },
    },
    ctaButton: {
      width: '100%',
    },
    secondaryCta: {
      '&:not(:first-child)': {
        marginTop: '20px',
      },
    },
    marketoCta: {
      '&:not(:first-child)': {
        marginTop: '20px',
      },
    },
    bgImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  }),
  { name: 'GenCTA' },
);

export default useStyles;
